// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { GroundTruthCounter } from "./GroundTruthCounter.gen";
import { GroundTruthJobStatus } from "./GroundTruthJobStatus.gen";

export interface IGroundTruthJobDebugInfo {
	compositeImageUrl: string | undefined;

	sourceImageUrls: string[] | undefined;

	compositeWidth: number | undefined;

	compositeHeight: number | undefined;

	tileRegionsJson: string | undefined;

	detectionsJson: string | undefined;

	stitchMs: number | undefined;

	inferenceMs: number | undefined;

	requestDate: string | undefined;

	completedDate: string | undefined;

	photoCount: number;

	totalCount: number | undefined;

	counter: GroundTruthCounter;

	counterModel: string | undefined;

	notes: string | undefined;

	errorMessage: string | undefined;

	status: GroundTruthJobStatus;

	seamsJson: string | undefined;

	$type?: string | undefined;
}
export class GroundTruthJobDebugInfo {
	constructor(data?: IGroundTruthJobDebugInfo) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.requestDate) { this.requestDate = new Date(data.requestDate); }
		if (data.completedDate) { this.completedDate = new Date(data.completedDate); }
	}

	compositeImageUrl: string | undefined;

	sourceImageUrls: string[] | undefined;

	compositeWidth: number | undefined;

	compositeHeight: number | undefined;

	tileRegionsJson: string | undefined;

	detectionsJson: string | undefined;

	stitchMs: number | undefined;

	inferenceMs: number | undefined;

	requestDate: Date | undefined = new Date();

	completedDate: Date | undefined;

	photoCount: number = 0;

	totalCount: number | undefined;

	counter: GroundTruthCounter = 0;

	counterModel: string | undefined;

	notes: string | undefined;

	errorMessage: string | undefined;

	status: GroundTruthJobStatus = 0;

	seamsJson: string | undefined;

	static $type: string = "CoreApi.Models.GroundTruthJobDebugInfo, ";
	$type?: string | undefined = GroundTruthJobDebugInfo.$type;
}

